<script setup lang="ts">
  const props = defineProps({
    prependIcon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    appendIcon: {
      type: String,
      default: null
    }
  })

  const emit = defineEmits(['click'])

  function handleClick(event: MouseEvent) {
    emit('click', event)
  }
</script>

<template>
  <v-btn
    class="text-none"
    variant="tonal"
    color="primary"
    :prepend-icon="props.prependIcon"
    :append-icon="props.appendIcon"
    :disabled="props.disabled"
    @click="handleClick"
  >
    <slot></slot>
  </v-btn>
</template>

<style scoped></style>
